import React from 'react'; 
import { useEffect, useLayoutEffect, useState, useRef } from 'react';
import WithConsumer from '../../context/WithConsumer';
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

const Front = ({ context }) => {
	
	const posts = () => context.posts;
    const post = posts()[0];
    
	const [portrait, setPortrait] = useState(false);
  
	useEffect(() => {
		window.addEventListener('resize', ()=>{
    		doResize();
    	});				        		
	}, []);
	
	function doResize() {
						
		let screenWidth = window.innerWidth;
		let screenHeight = window.innerHeight;
		let portrait = false;
		
		if (screenWidth < screenHeight) {
			portrait = true;
		}
				
		setPortrait(portrait);

	}
    
    if (post) {   
	    	
		return (					
			
			<div className="c-front">
			
				<div className="c-front__media">
					
					{portrait == false &&
						<>
							{post.media_type === 'image' &&
								<Image srcset={post.lscp_srcset} src={post.lscp_src} fitting={post.lscp_pos} />
							}
							{post.media_type !== 'image' &&
								<Cinemagraph src={post.lscp_src} fitting={post.lscp_pos} />
							}
						</>
					}
					
					{portrait == true &&
						<>
							{post.media_type === 'image' &&
								<Image srcset={post.port_srcset} src={post.port_src} fitting={post.port_pos} />
							}
							{post.media_type !== 'image' &&
								<Image src={post.port_src} fitting={post.port_pos} />
							}
						</>
					}
				
				</div>
				
			</div>	
									
		)
		
	} else {
		
		return null;
		
	}

};
export default WithConsumer(Front);